export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14158.2e2dedcf.jpg";